import errorDecorator from "@/components/fields/errors";

export default {
  mixins: [errorDecorator],

  data() {
    return {
      form: {},
      fields: [
        {
          key: "firstName",
          type: "input",
          templateOptions: {
            label: "First Name"
          },
          required: true
        },
        {
          key: "lastName",
          type: "input",
          templateOptions: {
            label: "Last Name"
          },
          required: true
        },
        {
          key: "title",
          type: "input",
          templateOptions: {
            label: "Title"
          },
          required: true
        },
        {
          key: "email",
          type: "input",
          templateOptions: {
            label: "email",
            inputType: "email"
          },
          required: true
        },
        {
          key: "currentPassword",
          type: "password",
          templateOptions: {
            label:
              "Current Password [leave blank if you are not updating your password]",
            score: 0
          },
          required: true
        },
        {
          key: "password",
          type: "password",
          templateOptions: {
            label:
              "Password [leave blank if you are not updating your password]",
            score: 0
          },
          required: true
        },
        {
          key: "notifyEmail",
          type: "checkbox",
          templateOptions: {
            label: "Interview Notify Email"
          },
          required: true
        }
      ]
    };
  }
};
